import React, { useMemo } from 'react';

export default function InvadersView() {
  const src = useMemo(() => {
    try {
      const base = import.meta.env.VITE_API_URL || '';
      return (base ? base.replace(/\/$/, '') : '') + '/api/public/invaders.html';
    } catch {
      return '/api/public/invaders.html';
    }
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', padding: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <h2 style={{ margin: 0 }}>Invaders</h2>
        <span style={{ opacity: 0.7, fontSize: 12 }}>Move: ← →, Shoot: Space, Start: Enter</span>
      </div>
      <div style={{ flex: 1, minHeight: 0, borderRadius: 6, overflow: 'hidden', boxShadow: '0 0 0 1px rgba(0,0,0,0.1)' }}>
        <iframe title="Invaders" src={src} style={{ border: 'none', width: '100%', height: '100%', background: '#222' }} />
      </div>
    </div>
  );
}

